'use client';

import NoibuScript from '@/app/head/NoibuScript';

import AffiliatesScript from './head/AffiliatesScript';
import AffirmScript from './head/AffirmScript';
import DecagonScript from './head/DecagonScript';
import KlarnaScript from './head/KlarnaScript';

const Scripts = () => {
  return (
    <>
      <AffiliatesScript />
      <AffirmScript />
      <NoibuScript />
      <DecagonScript />
      <KlarnaScript />
    </>
  );
};

export default Scripts;
